import React, {
  ReactNode,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import {
  AmenityDefinition,
  CreateAmenityDefinitionData,
} from "../../../graphql/models";
import { AmenityDefinitionForm } from "./amenity_definition_form";

import useAmenitiesDefinitionsStyle from "./amenities_definitions.style";
import { useUserState } from "../../../context";
import { ignoreDateDST } from "../../../utils";

function AmenitiesDefinitionsPage(props: any) {
  const classes = useAmenitiesDefinitionsStyle();

  const tableRef = useRef();

  const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formAmenityDefinition, setFormAmenityDefinition] = useState<
    AmenityDefinition | CreateAmenityDefinitionData | undefined
  >(void 0);

  const addNewAmenityDefinition = () => {
    setFormAmenityDefinition({} as AmenityDefinition);
    setFormDialogOpened(true);
  };

  const editAmenityDefinition = (row: AmenityDefinition) => {
    setFormAmenityDefinition(row);
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormAmenityDefinition(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback((row) => {
    const actions: ReactNode[] = [];
    actions.push(
      <EditButton onClick={() => editAmenityDefinition({ ...row })} />
    );

    return actions;
  }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    if (userRole === "system_admin" || userRole === "building_manager") {
      actions.push(
        <Button
          key="new-amenity-definition-button"
          variant="contained"
          color="primary"
          onClick={() => addNewAmenityDefinition()}
        >
          Aggiungi Nuovo
        </Button>
      );
    }
    return actions;
  }, [userRole]);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar
          title={"Operatività Servizi"}
          actions={actionToolbarActions}
        />
        <GqlTable
          ref={tableRef}
          columns={[
            "",
            "Attiva?",
            "Mostra in app?",
            "Struttura",
            // "Categoria",
            "Nome",
            "Dal",
            "Al",
            "Solo ad uso esclusivo?",
          ].map((v) => (
            <TableCell>{v}</TableCell>
          ))}
          query={QUERIES.AMENITIES_DEFINITIONS}
          queryResultDataField="amenitiesDefinitions"
          queryVariables={{
            includeHidden: true,
          }}
          rows={(row) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.active ? "Sì" : "No"}</TableCell>
              <TableCell>{row.hidden ? "No" : "Sì"}</TableCell>
              <TableCell>{row.building.name}</TableCell>
              {/* <TableCell>{row.serviceCategoryName}</TableCell> */}
              <TableCell>{row.name}</TableCell>
              <TableCell>
                {}
                {ignoreDateDST(new Date(row.periodFrom)).toLocaleDateString()}
              </TableCell>
              <TableCell>
                {ignoreDateDST(new Date(row.periodTo)).toLocaleDateString()}
              </TableCell>
              <TableCell>{row.alwaysEsclusive ? "Sì" : "No"}</TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica periodo operatività"}
        >
          <AmenityDefinitionForm
            value={formAmenityDefinition}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(AmenitiesDefinitionsPage);
